import * as React from "react";

import classNames from "classnames";

import GenButton from "../Gen/Button";
import GenLoadingSpinner from "../Gen/LoadingSpinner";
import GenSearchBox from "../Gen/SearchBox";

interface GenSidebarListControlsProps<Item extends {id: number}> {
  title: string
  connectedList: ConnectedList<Item>,
  search?: boolean,
  searchPlaceholder?: string,
  children?: React.ReactNode,
  afterFilterButtons?: React.ReactNode,
  hideSidebar?: boolean;
}

export default function GenSidebarListControls<Item extends {id: number}>(props: GenSidebarListControlsProps<Item>) {
  const {
    title,
    connectedList,
    search,
    searchPlaceholder,
    children,
    afterFilterButtons,
    hideSidebar,
  } = props;

  const [showMobileFilters, setShowMobileFilters] = React.useState(false);

  if (hideSidebar) { return null; }

  let closeFiltersButtonData;
  if (!connectedList.listData) {
    closeFiltersButtonData = {
      name: <GenLoadingSpinner highlighted/>,
    };
  } else if (connectedList.listData.length === 0) {
    closeFiltersButtonData = {
      name: "No Matches",
      alertColor: true,
    };
  } else {
    closeFiltersButtonData = {
      name: "View Matches",
    };
  }

  return (
    <div className="gen-list-controls">
      <div className="gen-list-title">
        <h1>{title}</h1>
        <GenButton
          name={<span><i className="fa fa-filter" />{connectedList.activeFilters && Object.keys(connectedList.activeFilters).length > 0 ? ` (${Object.keys(connectedList.activeFilters).length} Active)` : ""}</span>}
          highlighted
          loading={connectedList.isSyncing}
          onClick={() => setShowMobileFilters(!showMobileFilters)}
        />
      </div>

      {search && (
        <div className="gen-list-search">
          <GenSearchBox
            {...connectedList}
            placeholder={searchPlaceholder}
          />
        </div>
      )}

      <div className={classNames("gen-list-mobile-controls-panel", "fitlers", {"active-mobile-panel": showMobileFilters})}>
        <div className="gen-list-mobile-controls-panel-header">
          <h4>Filters</h4>
          <GenButton
            {...closeFiltersButtonData}
            loading={connectedList.isSyncing}
            onClick={() => setShowMobileFilters(!showMobileFilters)}
            highlighted
          />
        </div>
        <div className="gen-list-mobile-controls-panel-body">
          {children}
        </div>
      </div>

      {
        afterFilterButtons && (
          <div>
            {afterFilterButtons}
          </div>
        )
      }
    </div>
  );
}
